import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HelperService {
  private languageSubject = new BehaviorSubject<string>('en'); // Standard: Englisch
  private darkModeSubject = new BehaviorSubject<boolean>(false); // Standard: Light Mode

  language$ = this.languageSubject.asObservable();
  darkMode$ = this.darkModeSubject.asObservable();




  constructor() {
    // Lade gespeicherte Einstellungen aus Local Storage (falls vorhanden)
    const storedLang = localStorage.getItem('language');
    const storedTheme = localStorage.getItem('darkMode') === 'true';

    if (storedLang) this.languageSubject.next(storedLang);
    this.darkModeSubject.next(storedTheme);


  }

  setLanguage(lang: string) {
    this.languageSubject.next(lang);
    localStorage.setItem('language', lang); // Speichern der Auswahl
  }

  toggleTheme() {

    // **Icons umschalten**
    const icons = document.querySelectorAll('.toggle-theme i');
    icons.forEach(icon => {
      icon.classList.toggle('bx-sun');
    });

    const container = document.getElementById('container');
    const darkContainer = document.getElementById('dark-container-home');

    container.classList.toggle('active');
    darkContainer.classList.toggle('active');

  }


 escapeHTML(str: string): string {
    return str.replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }



}
